module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fontinfo effect1",
    style: (_vm.getStyle),
    attrs: {
      "id": "reservationPopup"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px",
      "margin-bottom": "15px"
    }
  }, [_vm._v("予約")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("x")]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "reservationForm"
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
      },
      "mouseup": function($event) {
        $event.stopPropagation();
      },
      "mousemove": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('table', {
    class: {
      errorDuplication: _vm.isSomeDuplicatedReservation
    },
    attrs: {
      "title": _vm.isSomeDuplicatedReservation ? '同時間帯に同じ講義が存在します' : '',
      "id": "timeinfo"
    }
  }, [_c('tr', [_vm._m(0), _vm._v(" "), _c('td', {
    staticClass: "timeinput"
  }, [_c('time-select', {
    attrs: {
      "value": _vm.$store.state.previewBox.start,
      "picker-options": {
        start: '10:00',
        end: '23:00',
        step: '00:05',
      }
    },
    on: {
      "input": _vm.updateStartTime
    }
  })], 1)]), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', {
    staticClass: "timeinput"
  }, [_c('time-select', {
    attrs: {
      "value": _vm.$store.state.previewBox.end,
      "picker-options": {
        start: '10:00',
        end: '23:00',
        step: '00:05',
        minTime: _vm.$store.state.previewBox.start
      }
    },
    on: {
      "input": _vm.updateEndTime
    }
  })], 1)])]), _vm._v(" "), _c('div', [(_vm.$store.state.userInfo.user_type === 'student') ? _c('div', [_c('label', {
    attrs: {
      "id": "type"
    }
  }, [_vm._v("授業の種類：\n      "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "id": "radioNormal",
      "value": "通常"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "通常")
    },
    on: {
      "change": function($event) {
        _vm.type = "通常"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radioNormal"
    }
  }, [_vm._v("通常授業")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "id": "radioNormalFirst",
      "value": "通常初回"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "通常初回")
    },
    on: {
      "change": function($event) {
        _vm.type = "通常初回"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radioNormalFirst"
    }
  }, [_vm._v("通常初回授業")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "id": "radioShort",
      "value": "短期"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "短期")
    },
    on: {
      "change": function($event) {
        _vm.type = "短期"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radioShort"
    }
  }, [_vm._v("短期講座")])])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'teacher' || _vm.$store.state.userInfo.user_type === 'admin') ? _c('div', [_c('label', {
    attrs: {
      "id": "type"
    }
  }, [_vm._v("授業の種類：\n      "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "id": "radioNormal",
      "value": "通常"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "通常")
    },
    on: {
      "change": function($event) {
        _vm.type = "通常"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radioNormal"
    }
  }, [_vm._v("通常授業")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "id": "radioNormalFirst",
      "value": "通常初回"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "通常初回")
    },
    on: {
      "change": function($event) {
        _vm.type = "通常初回"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radioNormalFirst"
    }
  }, [_vm._v("通常初回授業")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "id": "radioTrial",
      "value": "体験"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "体験")
    },
    on: {
      "change": function($event) {
        _vm.type = "体験"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radioTrial"
    }
  }, [_vm._v("体験授業")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "id": "radioShort",
      "value": "短期"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "短期")
    },
    on: {
      "change": function($event) {
        _vm.type = "短期"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radioShort"
    }
  }, [_vm._v("短期講座")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "id": "radioShortFirst",
      "value": "短期初回"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "短期初回")
    },
    on: {
      "change": function($event) {
        _vm.type = "短期初回"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "radioShortFirst"
    }
  }, [_vm._v("短期初回講座")])])]) : _vm._e()]), _vm._v(" "), (!_vm.isTanki) ? [_c('div', {
    staticClass: "nameinput"
  }, [_c('span', [_vm._v("生徒のお名前：")]), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'student') ? [_c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.$store.state.userInfo.fullname
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "hidden": ""
    },
    domProps: {
      "value": _vm.setHiddenID()
    }
  })] : (_vm.$store.state.userInfo.user_type === 'teacher') ? [_c('autocomplete', {
    attrs: {
      "type": 'student',
      "suggestions": _vm.getStudentList(),
      "placeholder": '生徒のお名前'
    },
    model: {
      value: (_vm.student),
      callback: function($$v) {
        _vm.student = $$v
      },
      expression: "student"
    }
  })] : [_c('autocomplete', {
    attrs: {
      "type": 'admin',
      "suggestions": _vm.getStudentList(),
      "placeholder": '生徒のお名前'
    },
    model: {
      value: (_vm.student),
      callback: function($$v) {
        _vm.student = $$v
      },
      expression: "student"
    }
  })]], 2), _vm._v(" "), _c('div', {
    staticClass: "nameinput"
  }, [_c('span', [_vm._v("先生のお名前：")]), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'teacher') ? [_c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.$store.state.userInfo.fullname
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "hidden": ""
    },
    domProps: {
      "value": _vm.setHiddenID()
    }
  })] : (_vm.$store.state.userInfo.user_type === 'student') ? [_c('autocomplete', {
    attrs: {
      "type": 'teacher',
      "suggestions": _vm.getTeacherList(),
      "placeholder": '先生のお名前'
    },
    model: {
      value: (_vm.teacher),
      callback: function($$v) {
        _vm.teacher = $$v
      },
      expression: "teacher"
    }
  })] : [_c('autocomplete', {
    attrs: {
      "type": 'admin',
      "suggestions": _vm.getTeacherList(),
      "placeholder": '先生のお名前'
    },
    model: {
      value: (_vm.teacher),
      callback: function($$v) {
        _vm.teacher = $$v
      },
      expression: "teacher"
    }
  })]], 2)] : _vm._e(), _vm._v(" "), (!_vm.isTanki) ? [_c('div', {
    staticClass: "nameinput",
    staticStyle: {
      "margin-top": "13px"
    }
  }, [_c('label', {
    attrs: {
      "id": "hasTest"
    }
  }, [_vm._v("配布物（確認テスト等）: "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasTest),
      expression: "hasTest"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hasTest = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("\n          有り\n        ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("\n          無し\n        ")])])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isOnline),
      expression: "isOnline"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isOnline) ? _vm._i(_vm.isOnline, null) > -1 : (_vm.isOnline)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isOnline,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isOnline = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isOnline = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isOnline = $$c
        }
      }
    }
  }), _vm._v(" オンライン授業"), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "message_area",
    attrs: {
      "id": "message",
      "placeholder": "連絡事項"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "予約をする",
      "disabled": !_vm.canTakeResv
    },
    on: {
      "click": _vm.takeReservation
    }
  }), _vm._v(" "), (_vm.type == '通常' || '短期') ? _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isRecurrent),
      expression: "isRecurrent"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isRecurrent) ? _vm._i(_vm.isRecurrent, null) > -1 : (_vm.isRecurrent)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isRecurrent,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isRecurrent = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isRecurrent = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isRecurrent = $$c
        }
      }
    }
  }), _vm._v("月末まで毎週予約する")]) : _vm._e(), _vm._v(" "), (_vm.isRecurrent) ? _c('recurrent-panel') : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.isTanki) ? [_c('temporaryLecturePanel', {
    attrs: {
      "teacher": _vm.teacher,
      "reservationType": _vm.type
    }
  }, [_c('span', [_vm._v("先生のお名前：")]), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'teacher') ? [_c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.$store.state.userInfo.fullname
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "hidden": ""
    },
    domProps: {
      "value": _vm.setHiddenID()
    }
  })] : (_vm.$store.state.userInfo.user_type === 'student') ? [_c('autocomplete', {
    attrs: {
      "type": 'teacher',
      "suggestions": _vm.getTeacherList(),
      "placeholder": '先生のお名前'
    },
    model: {
      value: (_vm.teacher),
      callback: function($$v) {
        _vm.teacher = $$v
      },
      expression: "teacher"
    }
  })] : [_c('autocomplete', {
    attrs: {
      "type": 'admin',
      "suggestions": _vm.getTeacherList(),
      "placeholder": '先生のお名前'
    },
    model: {
      value: (_vm.teacher),
      callback: function($$v) {
        _vm.teacher = $$v
      },
      expression: "teacher"
    }
  })]], 2)] : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("開始: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("終了: ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7cb9a1d0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cb9a1d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/timetable/ReservationPopup.vue
// module id = 734
// module chunks = 0